import {createAction} from "redux-act";
import {IChecksum} from "modules/reducers/checksums";

export const fetchChecksumsJSON = createAction();
export const fetchChecksumsJSONSuccess = createAction<IChecksum>();
export const fetchChecksumsJSONFailed = createAction<Error>();
